<template>

   <div class="req-container landscape" v-if="orientation === 'landscape'">
    <GameButton :disabled="true" ref="promptButtons" :icon="prompts[landscapeIndex].icon" :prompt="prompts[landscapeIndex].prompt"  :important="landscapeIndex > 0 ? false : true "/>
      <div class="landscape-buttons">
                <button @click="nextPrompt" class="reset">Next<FontAwesomeIcon icon="arrow-right"/></button>
                        <button @click="refreshOrientation" class="reset"><FontAwesomeIcon icon="refresh"/>Flip</button>

        <button @click="prevPrompt" class="reset"><FontAwesomeIcon icon="arrow-left"/>Previous</button>

      </div>
        

  </div>
  <div class="req-container" v-if="orientation === 'portrait'">
    <GameButton ref="promptButtons"  v-for="(prompt, index) in prompts" 
    :completed="true"
    :index="index"
    :key="index+prompt.icon" 
    :icon="prompt.icon" 
    :prompt="prompt.prompt" 
    :important="index > 0 ? false : true "/>
    <button @click="resetStates" class="reset"><FontAwesomeIcon icon="refresh"/>Reset</button>
  </div>

</template>
<script>
import GameButton from './ButtonComponent.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {getInitialFive} from '../db.js';
// const OGDATA = [
//         {
//           icon:'exclamation',
//           text:'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
//         },
//         {
//           icon:'baby',
//           text:'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
//         },
//         {
//           icon:'ankh',
//           text:'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
//         },
//         {
//           icon:'tree',
//           text:'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
//         },
//         {
//           icon:'heart',
//           text:'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
//         },
//         {
//           icon:'bridge-water',
//           text:'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
//         },

//       ]
    

export default {
  name: 'GameScreen',
  components:{
    GameButton,
    FontAwesomeIcon
  },
  async setup(){
    let prompts = [];
     if(localStorage.prompts != undefined){
      prompts = JSON.parse(localStorage.prompts)

    }
    else {
      prompts = await getInitialFive();
      localStorage.prompts = JSON.stringify(prompts)
      for(let x = 0; x < prompts.length; x++){
        localStorage.setItem(x, '0')
      }
    }

    return {
      prompts
    }

  },
  props: {
    msg: String,
    orientation: String
  },
  data(){
    return {
      landscapeIndex: 0
    }
  },

  methods:{
    resetStates(){
      this.$refs.promptButtons.forEach(p => p.reset())
    },
    refreshOrientation(){
      this.$parent.handleResize();
    },
    nextPrompt(){
      if(this.landscapeIndex < this.prompts.length-1) this.landscapeIndex++;
      else this.landscapeIndex = 0;
    },
    prevPrompt(){
    if(this.landscapeIndex > 0) this.landscapeIndex--;
          else this.landscapeIndex = this.prompts.length-1;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.req-container {
  flex:1;
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  padding: 20px 0 20px 0;
  align-items: center;
  gap: 10px;
  flex-direction: column;
  
}

.reset {
  width: 100px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  color:white;
  font-family: inherit;
  font-weight: bold;
  background: black;
  border-style: solid;
  border-radius: 10px;
  border-color: black;
  cursor: pointer;

}
.reset:hover {
  opacity: 0.8;
}
.reset:active {
  opacity: 0.6;
}

.landscape {
  justify-content: center !important;
  gap: 30px;
}
.landscape-buttons {
  width: 100%;
  justify-content: space-evenly;
  align-items: center;
  display: flex;
  flex-direction: row-reverse;
}



</style>
